import { render, staticRenderFns } from "./WhatsappNumbersConfiguration.vue?vue&type=template&id=6e825a14"
import script from "./WhatsappNumbersConfiguration.vue?vue&type=script&lang=js"
export * from "./WhatsappNumbersConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports